import { isNotNil } from "client/Misc/utils";
import { createContext } from "react";
import { unique } from "client_legacy/ndaw/arrayHelpers";
import styles from "./ControlAttachment.module.less";

export type ControlAttachmentKind =
	| "left"
	| "right"
	| "top"
	| "bottom";

export type ControlAttachmentOptions = ReadonlyArray<ControlAttachmentKind | undefined> | ControlAttachmentKind;

export type ControlAttachmentContextData = {
	attachedOn: ControlAttachmentOptions;
};

export const NO_CONTROL_ATTACHMENTS: ControlAttachmentContextData = {
	attachedOn: []
};

export const ControlAttachmentContext = createContext<ControlAttachmentContextData>(NO_CONTROL_ATTACHMENTS);

const styleForControlAttachmentKind: {[key in ControlAttachmentKind]: string} = {
	"left": styles.hasLeftAttachment,
	"right": styles.hasRightAttachment,
	"top": styles.hasTopAttachment,
	"bottom": styles.hasBottomAttachment
};

export function getAttachmentClassNames(...attachments: ControlAttachmentOptions[]): string {
	const flattenedAttachments: ReadonlyArray<ControlAttachmentKind> = combineAttachmentKinds(...attachments);
	return unique(flattenedAttachments.map(a => styleForControlAttachmentKind[a]))
		.join(" ");
}

export function combineAttachmentKinds(...attachments: ControlAttachmentOptions[]): ReadonlyArray<ControlAttachmentKind> {
	return attachments.reduce<ControlAttachmentKind[]>(
		(acc, cur): ControlAttachmentKind[] => [...acc, ...toArray(cur)],
		[]
	);
}

function toArray(attachments: ControlAttachmentOptions): ReadonlyArray<ControlAttachmentKind> {
	if (typeof attachments === "string") {
		return [attachments];
	}

	return attachments.filter(isNotNil);
}